export default __webpack_public_path__ + "04_FinalizeReport.e282da02.png";